import { Toast } from "@/components/ui/toast.tsx";
import { useFormattingLocale } from "@packages/core-client/i18n/useFormattingLocale.ts";
import { I18nProvider } from "@react-aria/i18n";
import { useCurrentLanguage } from "@squide/i18next";
import { lazy, useEffect } from "react";
import { Outlet } from "react-router";
import { useRuntimeMode } from "@squide/firefly";

const Devtools = lazy(() => import("@packages/devtools/client/Devtools.tsx"));

export function RootLayout() {
    const mode = useRuntimeMode();
    const locale = useFormattingLocale(useCurrentLanguage());

    useEffect(() => {
        document.documentElement.lang = locale;
    }, [locale]);

    return (
        <I18nProvider locale={locale}>
            <Toast closeButton />
            <Outlet />
            {mode === "development" && <Devtools />}
        </I18nProvider>
    );
}
